<div class="content">
    <div class="containerDataTable">

        <button type="button" class="btn  btn-primary btnCreate" (click)="openModal('', 'create', 0)">{{
            'userManagement.newUser' | translate }}</button>

        <h2 class="titleTable">{{ 'userManagement.userTitle' | translate }}</h2>
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
            class="table row-border hover dt-responsive nowrap">
            <thead>
                <tr class="tableHeader">
                    <th class="responsiveCol"></th>
                    <th>ID</th>
                    <th>{{ 'userManagement.name' | translate }}</th>
                    <th>{{ 'userManagement.surname' | translate }}</th>
                    <!--  <th>{{ 'userManagement.email' | translate }}</th>
                    <th>{{ 'userManagement.status' | translate }}</th> -->
                    <th>{{ 'userManagement.actions' | translate }}</th>

                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let user of data; let i = index">
                    <td> </td>
                    <td>{{ user.id }}</td>
                    <td>{{ user.fullName }}</td>
                    <td>{{ user.userName }}</td>
                    <!--   <td>---</td> -->
                    <!-- <td><span class="pill pill-{{user.controlEns | lowercase}}">{{user.controlEns |
                            uppercase}}</span></td> -->
                    <!--  <td><span class="pill pill-green">Active</span></td> -->
                    <td class="text-center">
                        <!-- <button
                            *ngIf="user.controlEns.toLowerCase()!=='orange' && user.controlEns.toLowerCase()!=='red'"
                            class="btn btnEdit" id="buttonEdituser" (click)="openEdit(user)"><i
                                class="icon-edit"></i></button> -->
                        <button class="btn btnEdit" id="buttonEdituser" (click)="openModal(user, 'Edit', i)"><i
                                class="icon-edit"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <app-modal #modal [modalConfig]="modalConfig">
        <form [formGroup]="form">
            <div class="row">
                <div class="col-6">
                    <div class="formField mb-3">

                        <input type="text" class="form-control modalInput" formControlName="nameControl">
                        <label alt="ctrl_ens" for="ctrl_ens" class="labelForm">{{ 'userManagement.name' | translate
                            }}</label>
                    </div>
                </div>
                <div class="col-6">
                    <div class="formField mb-3">
                        <input type="text" readonly class="form-control modalInput" formControlName="surnameControl">
                        <label alt="ctrl_ens_result" for="ctrl_ens_result" class="labelForm">{{ 'userManagement.surname'
                            | translate
                            }}</label>
                    </div>
                </div>
                <div class="col-12 pb-4">
                  <!--   <div class="formField mb-3">
                        <input type="text" class="form-control modalInput" formControlName="passwordControl">
                        <label alt="passwordInput" for="passwordControl" class="labelForm">{{ 'login.password' |
                            translate }}</label>
                    </div> -->
                    <div class="formField input-group  mb-3">
                        <input type="text" class="form-control passwordFile" minlength="6" maxlength="16"
                            [type]="fieldTextType ? 'text' : 'password'" aria-label="New Password" id="password"
                            formControlName="passwordControl"><button class="btn btn-eye" type="button"
                            (click)="toggleFieldTextType()"> <i
                                [ngClass]="{'icon-eye-close': !fieldTextType,  'icon-eye': fieldTextType }"></i></button>
                        <label alt="new_pass" for="password" class="labelForm">{{ 'login.password' | translate }}</label>

                    </div>
                </div>
                <!--    <div class="col-12 pb-4" *ngIf="!modalCreate">
                    <div class=" mb-3 toggle-switch">
                        <input type="checkbox" id="toggle-switch-1" formControlName="statusControl">
                        <label for="toggle-switch-1"></label>
                        <span *ngIf="userSelected.status" class="activeLabel">{{ 'userManagement.active' | translate
                            }}</span>
                        <span *ngIf="!userSelected.status" class="activeLabel">{{ 'userManagement.inactive' | translate
                            }}</span>
                    </div>
                </div> -->
                <div class="col-12 pb-4" *ngIf="modalCreate">
                    <p class="subText">{{ 'userManagement.mesaggeCreate' | translate }}</p>
                </div>
                <div class="col-12 pt-4 pb-2 colButtonForm" *ngIf="!modalCreate">
                    <button type="submit" class="btn btnReset btn-secondary float-start" (click)="deleteUser()">{{
                        'userManagement.delete' | translate }}</button>
                    <button type="submit" class="btn btnModalConfirm btn-primary float-end" (click)="editUser()"
                        [disabled]="!form.valid">{{ 'home.save' | translate }}</button>
                </div>
                <div class="col-12 pt-4 pb-2 colButtonForm" *ngIf="modalCreate">

                    <button type="submit" class="btn btnModalConfirm btn-primary float-end" (click)="createUser()"
                        [disabled]="!form.valid">{{ 'userManagement.createUser' | translate }}</button>
                </div>
            </div>


        </form>
    </app-modal>
</div>